import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step6-enforcer',
  templateUrl: './step6-enforcer.component.html',
  styleUrls: ['./step6-enforcer.component.scss'],
  animations: [
    trigger('bounceIn', [
      state('in', style({ opacity: 1, transform: 'scale(1)' })),
      transition('void => *', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('0.15s ease-in-out')
      ]),
      transition('* => void', [
        animate('0.15s ease-in-out', style({ opacity: 0, transform: 'scale(0.7)' }))
      ])
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.15s ease-in-out', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('0.15s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class Step6EnforcerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() scrollUp = new EventEmitter<number>();
  @ViewChild('suggestBox', { static: false }) suggestBox?: ElementRef;
  
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  title: string = 'Enforcer (Optional)';
  subtitle: string = 'Enforcer Information';
  uploadTitle: string = 'Upload Documents';

  relationLabel: string = 'Relationship To Settlor';
  relationHint: string = 'Specify Relationship';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';
  phoneLabel : string = 'Primary Phone Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';
  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA Number';
  kraHint: string = 'Enter KRA PIN Number';
  addressLabel: string = 'Postal Address';
  addressHint: string = 'Enter Postal Address';

  idFileLabel: string = 'Upload Copy of ID/Passport';
  kraFileLabel: string = 'Upload KRA PIN';

  addText: string = 'Enforcer details saved';
  updateText: string = 'Enforcer details updated'
  
  requiredFieldString: string = 'Required field';
  invalidDocString: string = 'Please attach a valid document';

  loadingText: string = 'Saving Enforcer Details';

  selfRecords: any = []; // For suggesting self
  recordUpdate: any;


  formErrors: { [key: string]: string } = {
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Phone: '',
    Email: '',
    Relationship: '',
    Other: '',

    IDNo: '',
    KraPin: '',
    Address: '',

    IDNoImage: '',
    KraPinImage: '',
  };

  validationMessages: { [key: string]: {} } = {
    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing enforcer' },
    Email: { required: this.requiredFieldString, email: "Invalid email address" },

    Relationship: { required: this.requiredFieldString },
    Other: {required: this.requiredFieldString},
    IDNo:  { required: this.requiredFieldString, pattern:'Invalid ID or Passport number', exist: 'This ID is tied to an existing enforcer' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing enforcer' },
    Address: { required: this.requiredFieldString },

    IDNoImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    KraPinImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
  };


  enforcerForm = this._formBuilder.group({
    Title: [''],
    FirstName: ['', Validators.required],
    MiddleName: [''],
    LastName: ['', Validators.required],
    Phone: ['', Validators.required],
    Email: ['', [Validators.required, Validators.email]],
    Relationship: ['', Validators.required],
    Other: [],

    IDNo: ['', Validators.required],
    KraPin: ['', (this.region == 1 ? Validators.pattern(/^[AP]\d{9}[A-Z]$/) : [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)])],
    Address: ['', Validators.required],

    IDNoImage: [''],
    KraPinImage: ['']
  });


  loadingRemove: boolean = false;
  enforcerPanel: ExpansionPanel[][] = [];
  private formChangesSubscription: Subscription[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private validationService: ValidationService,
    private dialog: MatDialog,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const records: any = this.settlors;
    this.selfRecords.push(records[0]);
    if (records.length > 1) this.selfRecords.push(records[1]);

    this.populateData();

    if (this.enforcer) {
      this.patchFormValues(this.enforcer);
    }

    this.checkTrusteeSelf();
    this.showSuggestBrief();

    this.validationService.addOrRemoveValidationOnValue(
      this.enforcerForm.get("Relationship")!,
      "Other",
      this.enforcerForm,
      "Other"
    );

    this.enforcerPanel[0] = this.generatePanels();
    this.setupFormChangeListeners();

    this.enforcerForm.valueChanges.subscribe(()=> {
      this.logErrors();
    })
  }

  ngAfterViewInit() {
    this.enforcerPanel[0] = this.generatePanels();
  }
  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.enforcerForm,
      this.formErrors,
      this.validationMessages
    );
  }

  get region(): any {
    return this.estateControlService.regionType;
  }
  get loading(): boolean {
    return this.notificationService.loading;
  }
  get enforcer(): any {
    return this.estateControlService.enforcer;
  }
  get trustees(): any {
    return this.estateControlService.trustees;
  }
  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }
  get RelationOptions():any {
    return this.tabControlService.RelationOptions;
  }
  Relationships: any = this.RelationOptions;

  get saveProgress(): ()=> void {
    return this.estateControlService.saveProgress;
  }

  checkTrusteeSelf() {
    if (this.arraysContainValue(this.trustees, 'Self')) {
      this.Relationships = this.RelationOptions.filter((option: string) => option !== 'Self');
    }
  }

  arrayContainsValue(arr: string | null | undefined, value: string) {
    return arr && arr.includes(value);
  }

  arraysContainValue(arr: any[] | null | undefined, value: string) {
    let exists = false

    if (arr)
      arr.forEach(element => {
        if (element.Relationship && element.Relationship.length > 0) {
          if (this.arrayContainsValue(element.Relationship, value)) exists = true;
        }
      });

      return exists;
  }

  // Autofill settlors
  showSuggestHint: boolean = false;
  showAssignPopup: boolean = false;
  autofilled: boolean = false;
  suggestions: any = null;
  briefTimeout: any;

  get settlors(): any {
    return this.estateControlService.settlors;
  }

  showSuggestBrief(): void {
    setTimeout(() => {
      this.showSuggestHint = true;
    }, 1000);

    this.briefTimeout = setTimeout(() => {
      this.showSuggestHint = false;
    }, 30000);
  }
  patchFormValues(enforcer: any, isResuming: boolean = true, value: any = null): void {
    if (enforcer) {
      this.enforcerForm = this._formBuilder.group({
        Title: [`${enforcer.Title || ''}`],
        FirstName: [`${enforcer.FirstName || ''}`, Validators.required],
        MiddleName: [`${enforcer.MiddleName || ''}`],
        LastName: [`${enforcer.LastName || ''}`, Validators.required],
        Phone: [`${enforcer.Phone || ''}`, Validators.required],
        Email: [`${enforcer.Email || ''}`, [Validators.required, Validators.email]],
    
        Relationship: [`${value ? value : enforcer.Relationship || ''}`, Validators.required],
        Other: [enforcer?.Other],
        IDNo: [`${enforcer.IDNo || ''}`, Validators.required],
        KraPin: [`${enforcer.KraPin || ''}`, (this.region == 1 ? Validators.pattern(/^[AP]\d{9}[A-Z]$/) : [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)] )],
        Address: [`${enforcer.Address || ''}`, Validators.required],
    
        IDNoImage: [''],
        KraPinImage: ['']
      });

      if (enforcer.IDNoImage) {
        this.enforcerForm.get('IDNoImage')?.setValue(enforcer.IDNoImage.stringValue);
        if (!isResuming) this.updateIDObject(enforcer.IDNoImage);
        // console.log('New ID :\n', this.idObject);
      }

      if (enforcer.KraPinImage) {
        this.enforcerForm.get('KraPinImage')?.setValue(enforcer.KraPinImage.stringValue);
        if (!isResuming) this.updateKraObject(enforcer.KraPinImage);
        // console.log('New KRA PIN :\n', this.kraObject);
      }

      if (isResuming) {
        if (enforcer.verified) {
          this.validationService.addOrRemoveValidator(true, this.enforcerForm.get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, this.enforcerForm.get('KraPinImage')!);
        }

        if (!enforcer.done) {
          // Autofill for self relationship
          this.selfRecords.some((record: any) => {
            if (
              enforcer.Relationship == 'Self' &&
              enforcer.FirstName == record.FirstName &&
              enforcer.LastName == record.LastName &&
              enforcer.Phone == record.Phone &&
              enforcer.Email == record.Email
            ) {
              this.recordUpdate = record;
              if (record.IDNoImage.stringValue && record.IDNoImage.stringValue.length > 0) {
                this.enforcerForm.get('IDNoImage')?.setValue(record.IDNoImage.stringValue);
              }
              if (record.KraPinImage.stringValue && record.KraPinImage.stringValue.length > 0) {
                this.enforcerForm.get('KraPinImage')?.setValue(record.KraPinImage.stringValue);
              }
            }
          })
        }
      }

      if (value || enforcer.Relationship == 'Self') {
        this.toggleFormControls(false);
        if (this.estateControlService.activeTab == 6) {
            this.notificationService.viewToast(
              'info',
              `Enforcer ${enforcer.FirstName+' '+enforcer.LastName} is an existing settlor.`,
              `To modify previously saved details and documents, edit the settlor record itself`
            );
          }
      }
      this.enforcerForm.markAsDirty();
    }
  }
  async suggestSettlors(val: string): Promise<any> {
    if (this.autofilled) {
      this.resetForm();
    }
    
    this.suggestions = null;
    let validEntries: any = [];

    if (val.length > 2) {
        try {
            for (let i = 0; i < this.settlors.length; i++) {
                let exist = false;
                let trueStuff = this.settlors[i].IDNo.includes(val);

                if (trueStuff) {
                  if (
                      this.enforcerForm.get('IDNo')?.value === this.settlors[i].IDNo ||
                      this.enforcerForm.get('Phone')?.value === this.settlors[i].Phone ||
                      this.enforcerForm.get('KraPin')?.value === this.settlors[i].KraPin) {
                      exist = true;
                  } else {
                    this.showSuggestHint = false;
                    clearTimeout(this.briefTimeout);
                  }

                  if (!exist && validEntries.length < 3 && !validEntries.some((entry: { IDNo: string; }) => entry.IDNo === this.settlors[i].IDNo)) {
                      validEntries.push(this.settlors[i]);
                  }
                }
            }

            if (validEntries.length > 0) {
              this.suggestions = validEntries;
            }
            if (this.suggestions !== null) {
              const childDivHeight = this.suggestBox?.nativeElement.clientHeight;
              this.scrollUp.emit(childDivHeight);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return this.suggestions;
  }
  patchSuggestedValues(value: any): void {
    try {
      if (value) {
        this.patchFormValues(value, false);
        this.suggestions = null;
        this.autofilled = true;
      }

    } catch (error) {
      console.error('ERR ??? ', error);
    }
  }

  // ========================================================

  updateIDObject(object: any): void {
    const latestRecord = this.enforcer;
    let updatedRecord = {
      ...latestRecord,
      ...{IDNoImage: object}
    };
    this.estateControlService.updateRecord(6, updatedRecord);
  }
  updateKraObject(object: any): void {
    const latestRecord = this.enforcer;
    let updatedRecord = {
      ...latestRecord,
      ...{KraPinImage: object}
    };
    this.estateControlService.updateRecord(6, updatedRecord);
  }

  resetForm() {
    if (this.autofilled) this.autofilled = false;
    this.enforcerForm.reset();
    this.enforcerForm.markAsUntouched();
    this.estateControlService.enforcer = {verified: false, done: false};
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0 && !this.tabControlService.loadingTitles) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
  }

  onRelationshipChange(): void {
    const value = this.enforcerForm.get('Relationship')?.value;
    if (value) {
      switch (value.toLowerCase()) {
        case 'self':
          this.recordUpdate = this.selfRecords[0];
          this.patchFormValues(this.recordUpdate, false, value);
          this.toggleFormControls(false);

          break;
        default:
          this.toggleFormControls(true);
          break;
      }
    }
  }

  toggleFormControls(enabled: boolean): void {
    if (enabled) { // Reset form when relationship != self
      const isSelfRecord: boolean = this.selfRecords.some((record: any) => {
        return this.enforcerForm.get('IDNo')?.value == record.IDNo;
      });

      if (isSelfRecord) {
        this.enforcerForm.get('Title')?.enable();
        this.enforcerForm.get('FirstName')?.enable();
        this.enforcerForm.get('MiddleName')?.enable();
        this.enforcerForm.get('LastName')?.enable();
        this.enforcerForm.get('Phone')?.enable();
        this.enforcerForm.get('Email')?.enable();
        this.enforcerForm.get('IDNo')?.enable();
        this.enforcerForm.get('KraPin')?.enable();
        this.enforcerForm.get('Address')?.enable();
        this.enforcerForm.get('IDNoImage')?.enable();
        this.enforcerForm.get('KraPinImage')?.enable();

        this.enforcerForm.get('Title')?.setValue('');
        this.enforcerForm.get('FirstName')?.setValue('');
        this.enforcerForm.get('MiddleName')?.setValue('');
        this.enforcerForm.get('LastName')?.setValue('');
        this.enforcerForm.get('Phone')?.setValue(' ');    
        this.enforcerForm.get('Email')?.setValue('');
        this.enforcerForm.get('IDNo')?.setValue('');
        this.enforcerForm.get('KraPin')?.setValue('');
        this.enforcerForm.get('Address')?.setValue('');
        this.enforcerForm.get('IDNoImage')?.setValue('');
        this.enforcerForm.get('KraPinImage')?.setValue('');
      }

    } else {
      // For 'self' option under relationship
      this.enforcerForm.get('Title')?.disable();
      this.enforcerForm.get('FirstName')?.disable();
      this.enforcerForm.get('MiddleName')?.disable();
      this.enforcerForm.get('LastName')?.disable();
      this.enforcerForm.get('Phone')?.disable();
      this.enforcerForm.get('Email')?.disable();  
      this.enforcerForm.get('IDNo')?.disable();
      this.enforcerForm.get('KraPin')?.disable();
      this.enforcerForm.get('PostalAddress')?.disable();
      this.enforcerForm.get('IDNoImage')?.disable();
      this.enforcerForm.get('KraPinImage')?.disable();
    }
    this.enforcerForm.updateValueAndValidity();
  }

  async removeEnforcer(): Promise<void> {}
  
  async saveEnforcer(): Promise<void> {
    if (this.enforcer.verified == true) this.loadingText = 'Updating Enforcer';
    else this.loadingText = 'Saving Enforcer';

    this.notificationService.isLoading(true);
    try {
      let data: any = {...this.enforcerForm.getRawValue(), ...{TrustID: this.estateControlService.TrustID}};

      if (data.Other && data.Other != '') {
        const other = data.Other;
        data.Relationship = other;
      }
      if (data.hasOwnProperty('Other')) {
        delete data['Other'];
      }
      
      const relation = data.Relationship.toLowerCase();
      if (this.enforcer.verified || this.autofilled || relation == 'self') {
        data.IDNoImage = this.enforcer.IDNoImage;
        data.KraPinImage = this.enforcer.KraPinImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
        data.KraPinImage = {name: '', stringValue: ''};
      }

      if (this.enforcer.EnforcerID) {
        data = {...data, ...{EnforcerID: this.enforcer.EnforcerID}};
      }

      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.privateEnforcerURL, data);
      
      // console.log('::::: RESPONSE ::::::\n', response);
      if (response.Status === 1) {
        let updatedRecord = {...data, ...{EnforcerID: response.EnforcerID}};

        if (this.enforcer.verified || this.autofilled || relation == 'self') {
          if (response.IdURL) {
            if (relation != 'self') {
              this.estateControlService.removeFromDocSummary('ID', 'Enforcer', this.enforcer.EnforcerID);
              this.estateControlService.updateDocSummary(response.IdURL);
            }
            updatedRecord = {...updatedRecord, ...{IDURL: response.IdURL, SavedID: this.enforcer.IDNoImage}};
          }
          if (response.KraURL) {
            if (relation != 'self') {
              this.estateControlService.removeFromDocSummary('PIN', 'Enforcer', this.enforcer.EnforcerID);
              this.estateControlService.updateDocSummary(response.KraURL);
            }
            updatedRecord = {...updatedRecord, ...{KraURL: response.KraURL, SavedPIN: this.enforcer.KraPinImage}};
          }

          if (this.autofilled || relation == 'self') {
            this.autofilled = false;
            this.estateControlService.updateRecord(6, {...updatedRecord, ...{verified: true, done: true}});
          } else {
            this.estateControlService.updateRecord(6, {...updatedRecord, ...{done: true}});
          }
          
          this.notificationService.viewToast('success', 'Enforcer details saved');
          
        } else {
          this.validationService.addOrRemoveValidator(true, this.enforcerForm.get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, this.enforcerForm.get('KraPinImage')!);
          
          this.estateControlService.updatePrivateTrustProgress('Enforcer');
          
          this.estateControlService.updateRecord(6, {...updatedRecord, ...{verified: true}});
          this.notificationService.viewToast('success', 'Enforcer details updated');
          this.updateDoneStatus();
        }
        
      } else {
        this.notificationService.viewToast('error', response.Message);
      }

    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }


  // ==============  EXPANSION SECTION   =================
  @ViewChild('enforcerInfo') enforcerInfo!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;
  
  
  generatePanels = (): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.enforcerInfo || !this.uploadDocs || !this.enforcer) {
      return [];
    }
    return [
      {
        title: 'Enforcer Information',
        contentTemplate: this.enforcerInfo,
        context: { index: 0 },
        expanded: !(this.enforcer.verified),
        done: (this.enforcer.verified)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocs,
        context: { index: 0 },
        disabled: !(this.enforcer.verified),
        expanded: (this.enforcer.verified && !this.enforcer.done),
        done: (this.enforcer.done)
      }
    ];
  }

  updateDoneStatus() {
    // Ensure panels array exists
    this.enforcerPanel = this.enforcerPanel || {};
    
    // Initialize if missing or invalid
    if (!this.enforcerPanel[0] || this.enforcerPanel[0].length !== 2) {
      this.enforcerPanel[0] = this.generatePanels();
    }

    const panels = this.enforcerPanel[0];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = this.enforcer.verified;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: 0 };
      panels[0].expanded = !this.enforcer.verified;
    }
    
    if (panels[1]) {
      panels[1].done = this.enforcer.done;
      panels[1].context = panels[1].context || { index: 0 };
      panels[1].disabled = !this.enforcer.verified;
      panels[1].expanded = !this.enforcer.done;
    }

    setTimeout(()=> {
      try {
        if (this.enforcer.EnforcerID && !this.enforcer.done) {
          this.notificationService.viewToast(
            'info',
            `Enforcer ${this.enforcer.FirstName} ${this.enforcer.LastName}`,
            `Please continue to ${panels[1].title}`
          );
        }
        
      } catch (error) {}
    })
  }

  private setupFormChangeListeners() {
    this.cleanupFormChangeListeners();

    // General form changes
    const subscription = (this.enforcerForm as FormGroup).valueChanges.subscribe(() => {
      this.cdr.detectChanges();
    });
    this.formChangesSubscription.push(subscription);
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }

  private loggedErrors = new Set<string>();

  confirmFormMatchesRecord(): boolean {
    try {
      const enforcer = this.enforcer;
      const formGroup = this.enforcerForm;
      
      if (!enforcer?.done || !formGroup) {
        return true;
      }

      const fieldsToCompare = [
        'Title', 'FirstName', 'MiddleName', 'LastName', 'Phone',
        'Email',  'IDNo','KraPin', 'Address', 'Relationship', 'Other'
      ];

      // Compare all relevant fields
      const basicFieldsMatch = fieldsToCompare.every(field => {
        const recordValue = enforcer[field];
        const formValue = formGroup.get(field)?.value;
        const valuesMatch = (formValue || '') === (recordValue || '');

        // If either value is empty, consider this field as matching
        return valuesMatch;
      });

      const filesMatch =
        enforcer.IDNoImage.name === enforcer.SavedID.name &&
        enforcer.KraPinImage.name === enforcer.SavedPIN.name;

      return basicFieldsMatch && filesMatch;
    } catch (error: any) {
      const errorKey = `error-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }
  

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++

  submitForm(): void {
    if (!this.enforcerForm.touched && !this.enforcer.verified ||
      (this.enforcer.done === true && this.confirmFormMatchesRecord())
    ) {
      this.navigateFunction();
    } else {
      this.saveEnforcer();
    }
  }

  async updateProgress(): Promise<void> {
    if (this.enforcerForm.touched && !this.enforcer.done && this.enforcerForm.valid) await this.saveEnforcer();
    this.saveProgress();
  }

  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTab(7);
    this.estateControlService.page6Done = true;
  }
}
